/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `1` - single
 * * `2` - double
 * @export
 */
export const OutputPrecisionEnum = {
  SINGLE: 1,
  DOUBLE: 2,
} as const;
export type OutputPrecisionEnum = (typeof OutputPrecisionEnum)[keyof typeof OutputPrecisionEnum];

export function instanceOfOutputPrecisionEnum(value: any): boolean {
  for (const key in OutputPrecisionEnum) {
    if (Object.prototype.hasOwnProperty.call(OutputPrecisionEnum, key)) {
      if (OutputPrecisionEnum[key as keyof typeof OutputPrecisionEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function OutputPrecisionEnumFromJSON(json: any): OutputPrecisionEnum {
  return OutputPrecisionEnumFromJSONTyped(json, false);
}

export function OutputPrecisionEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutputPrecisionEnum {
  return json as OutputPrecisionEnum;
}

export function OutputPrecisionEnumToJSON(value?: OutputPrecisionEnum | null): any {
  return value as any;
}

export function OutputPrecisionEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): OutputPrecisionEnum {
  return value as OutputPrecisionEnum;
}
